module.exports = __webpack_public_path__ + "89c5ae1532f8b61c60c31f37febaf2d7.png";